import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleLeftMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronTriangleLeftMedium"><Path d="M12.9423 7.16228C13.7546 6.47514 14.9997 7.05247 14.9999 8.11638V15.882C14.9999 16.9462 13.7547 17.5235 12.9423 16.8361L8.35346 12.9533C7.76376 12.454 7.76363 11.5443 8.35346 11.0451L12.9423 7.16228Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleLeftMedium;
